import { render } from "./Index.vue?vue&type=template&id=779ae854"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/ecstatic-ride.91-210-227-178.plesk.page/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__